import { config } from "/app.config"

export default config.isZeno
  ? [
      {
        path: "/onboarding/",
        name: "onboarding",
        component: () => import("@/views/Onboarding/Onboarding"),
        meta: {
          pageTitle: "Onboarding",
          rule: "owner",
          hideMenu: true,
        },
        children: [
          {
            path: "/onboarding/account/",
            name: "onboarding.account",
            component: () => import("@/views/Onboarding/OnboardingCreateAccount.vue"),
            meta: {
              pageTitle: "Create Account",
              rule: "owner",
              hideMenu: true,
            },
          },
          {
            path: "/onboarding/:accountKey/plan/",
            name: "onboarding.plan",
            component: () => import("@/views/Onboarding/OnboardingChoosePlan.vue"),
            meta: {
              pageTitle: "Choose a plan",
              rule: "owner",
              hideMenu: true,
            },
          },
          {
            // Alternative plan + add-ons screen (not part of the default onboarding flow yet).
            // Reachable directly for QA / a future A/B test of OnboardingChoosePlan.
            path: "/onboarding/:accountKey/plan-addons/",
            name: "onboarding.plan.addons",
            component: () => import("@/views/Onboarding/OnboardingChoosePlanAddon.vue"),
            meta: {
              pageTitle: "Choose a plan",
              rule: "owner",
              hideMenu: true,
            },
          },
          {
            // Legacy success/cancel URL kept for Stripe sessions created before `checkout.complete`
            // existed. Same component; without `flow`/`returnUrl` it defaults to onboarding targets.
            path: "/onboarding/:accountKey/subscribing/",
            name: "onboarding.subscribing",
            component: () => import("@/views/Checkout/CheckoutComplete.vue"),
            meta: {
              pageTitle: "Subscribing",
              rule: "owner",
              hideMenu: true,
            },
          },
          {
            path: "/onboarding/:accountKey/station/",
            name: "onboarding.station",
            component: () => import("@/views/Onboarding/OnboardingCreateStation.vue"),
            meta: {
              pageTitle: "Create Station",
              rule: "owner",
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: "/onboarding/recover/",
        name: "onboarding.recover",
        component: () => import("@/views/Onboarding/OnboardingRecoverAccount.vue"),
        meta: {
          pageTitle: "Recover Account",
          rule: "owner",
          hideMenu: true,
        },
      },
    ]
  : []
